#import "../../DepartmentFields.graphql"
mutation DepartmentCreate($input: DepartmentCreateInput!) {
  departmentCreate(input: $input) {
    department {
      ...DepartmentFields
    }
  }
}
